// ─────────────────────────────────────────────────────────────
// SINGLE SOURCE OF TRUTH FOR BRAND IDENTITY
// Change the name / tagline / colors here and the whole app updates.
// ─────────────────────────────────────────────────────────────

export const brand = {
  name: "WYVN",
  wordmark: "WYVN",
  suffix: "",
  tagline: "Win daily. Woven forever.",
  // W.Y.V.N — the meaning behind the mark
  acronym: ["Win", "Your", "Victory", "Now"],
  subline:
    "A global wellness movement built from small daily wins \u2014 woven together into something no one person could build alone.",
  domain: "wyvn.app",
  site: "getwyvn.com",
  email: "support@getwyvn.com",
  social: {
    instagram: "https://www.instagram.com/getwyvnapp",
    instagramHandle: "@getwyvnapp",
    tiktok: "https://www.tiktok.com/@wyvn.app",
    tiktokHandle: "@wyvn.app",
  },

  // App store links. Leave a value empty to show a "Coming soon" badge instead of a live link.
  stores: {
    appStore: "",
    playStore: "https://play.google.com/store/apps/details?id=com.wyvn.app",
  },

  // Soft-blue premium palette (mirrors CSS variables in index.css)
  colors: {
    primary: "#6AA6FF",
    primaryDeep: "#3E7BE6",
    primarySoft: "#A9CCFF",
    gold: "#D4924A",
    sage: "#7A9E7E",
    bg: "#0B0D12",
    surface: "#14171F",
    card: "#1B1F2A",
    text: "#F5F7FA",
    muted: "#98A2B3",
  },

  nav: [
    { label: "Mission", href: "#mission" },
    { label: "The App", href: "#app" },
    { label: "Members", href: "#map" },
    { label: "Pricing", href: "#pricing" },
    { label: "Stories", href: "#reviews" },
  ],
};

export default brand;
